import React, {useContext} from 'react';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import Calendar from '@views/orders/Calendar';

export default function OrderProductCalendar({rowIndex: index}: { rowIndex: number }) {
    const {fieldName} = useContext(FormFieldItemPropsContext) ?? {};

    return <Calendar
            rowIndex={index}
            label="OrderForm.products.fields.order_product_deadline"
            name={`${fieldName}.${index}.deadline_at`}
    />;
}
